import * as KatalMetrics from '@amzn/katal-metrics';
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi';
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';

const STAGE = 'prod';
const REGION = 'us-east-1';
const DOMAIN = {
  beta: 'test',
  gamma: 'test',
  prod: 'prod',
};
const REALM = {
  'eu-west-1': 'EUAmazon',
  'us-east-1': 'USAmazon',
  'us-west-2': 'FEAmazon',
};

/** Get the domain for the given stage. Defaults to 'prod' if not found. */
export const getDomainForStage = (stage: string) => DOMAIN[stage] ?? 'prod';

/** Get the realm for the given region. Defaults to 'USAmazon' if not found. */
export const getRealmForRegion = (region: string) => REALM[region] ?? 'USAmazon';

// eslint-disable-next-line no-console
const metricsConsoleErrorHandler = (err: Error) => console.error(err);

const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
  if (process.env.NODE_ENV === 'test') {
    const metricsDriver = new KatalMetricsDriverArrayCollector();
    //  Attach to global window object so tests can see it
    (window as any).metricsDriver = metricsDriver;
    return metricsDriver;
  }
  if (process.env.NODE_ENV !== 'production') {
    return new KatalMetricsDriverConsoleLogJson();
  }
  return new KatalMetricsDriverSushi.Builder()
    .withDomainRealm(getDomainForStage(STAGE), getRealmForRegion(REGION))
    .withErrorHandler(metricsConsoleErrorHandler)
    .build();
};

const makePublisher = (): KatalMetrics.Publisher => {

  const metricsDriver = makeMetricsDriver();
  const initialMetricsContext = new KatalMetrics.Context.Builder()
    .withSite('Retail')
    .withServiceName('PublicNoticeForm')
    .build();
  return new KatalMetrics.Publisher(
    metricsDriver,
    metricsConsoleErrorHandler,
    initialMetricsContext
  );
};

const initialMetricsPublisher = makePublisher();

export default initialMetricsPublisher;
